<app-spinner [isLoading]="isLoadingSpinner"></app-spinner>

<div class="payer-shell">
  <app-payer-header
    [merchantName]="currentMerchant?.name"
    [merchantLogoUrl]="currentMerchant?.strictly?.logoUrl || null"
  ></app-payer-header>

  <main class="payer-main">
    <div class="page-width-auth u-full-width">
      <div class="card card-elevated">
        <div class="card-body preparing-card-body">
          <h1>Preparing your secure payment</h1>
          <p>
            Don't close this page — we're creating a one-time payment link
            for this invoice.
          </p>

          <div class="preparing-summary" *ngIf="currentMerchant && invoice">
            <div class="preparing-summary-row">
              <span class="text-caption">Merchant</span>
              <span>{{ currentMerchant.name }}</span>
            </div>
            <div class="preparing-summary-row">
              <span class="text-caption">Invoice</span>
              <span class="company-id-code">INV-{{ invoice.DocNumber }}</span>
            </div>
            <div class="preparing-summary-row">
              <span class="text-caption">Amount</span>
              <span>{{ invoice.Balance | currency }}</span>
            </div>
          </div>

          <div class="progress-track" aria-hidden="true">
            <div class="progress-fill progress-fill-full"></div>
          </div>
          <p class="text-caption preparing-note">Verifying the invoice…</p>

          <a *ngIf="paymentLinkUrl" [href]="paymentLinkUrl" class="text-small text-link">
            Not moving? Open the checkout manually
          </a>
        </div>
      </div>
    </div>
  </main>

  <div class="payer-secure-badge-row" *ngIf="currentMerchant">
    <span class="payer-secure-badge">
      <svg class="icon icon-sm" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z" />
        <path d="M9 12l2 2 4-4" />
      </svg>
      Secure payment
    </span>
  </div>
</div>
